import { useOxygen } from '../../../providers/OxygenProvider';
import { Assignee } from '../../../sdk';
import { getAssigneeDisplayNameWithCompanyName } from '../../../helpers';
import { InlineLoader, LoaderStyle } from '../../InlineLoader';

type ToolTipContentProps = {
  assignees: Assignee[];
};

export const ToolTipContent = ({ assignees }: ToolTipContentProps) => {
  const oxygen = useOxygen();

  if (oxygen.loading) {
    return <InlineLoader loaderStyle={LoaderStyle.Spinny} />;
  }

  return (
    <div>
      {assignees.map((assignee) => {
        const displayName = getAssigneeDisplayNameWithCompanyName(oxygen, assignee);
        return <div key={assignee.id}>{displayName}</div>;
      })}
    </div>
  );
};
